import React from 'react';
import { LUXURY_PACKAGE } from '../mock';
import { Check, ChevronRight, Crown, Home, Building2, ShieldCheck, Sparkles } from 'lucide-react';
import { Button } from './ui/button';

export default function LuxurySection({ onBook }) {
  const p = LUXURY_PACKAGE;
  return (
    <section id="luxury" className="relative py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto mb-10">
          <div className="section-title-eyebrow uppercase">Exclusive</div>
          <h2 className="mt-3 text-3xl md:text-5xl font-extrabold">
            <span className="text-white">Luxury Car </span><span className="gradient-text">Care</span>
          </h2>
          <p className="mt-4 text-gray-400">લક્ઝરી અને પ્રીમિયમ કાર માટે ખાસ સર્વિસ — ઘર/ઓફિસથી ફ્રી પિકઅપ.</p>
        </div>

        <div className="rounded-3xl p-[1.5px] hover-lift" style={{background:'linear-gradient(90deg,#a855f7,#ec4899)'}}>
          <div className="rounded-3xl bg-[#0f0f16] p-6 md:p-10 grid lg:grid-cols-2 gap-8 items-center">
            <div>
              <div className="tag-pill mb-4"><Crown className="w-3 h-3" /> {p.tag}</div>
              <h3 className="text-3xl font-extrabold text-white">{p.name}</h3>
              <div className="text-xs tracking-widest text-gray-400 mt-1">{p.subtitle}</div>
              <div className="mt-5 flex items-baseline gap-3">
                <div className="text-5xl font-extrabold gradient-text">₹{p.offerPrice.toLocaleString()}</div>
                <div className="text-sm text-gray-400">+ GST</div>
              </div>
              <div className="mt-1 flex items-center gap-2 text-sm">
                <span className="text-gray-500 line-through">₹{p.marketPrice.toLocaleString()}</span>
                <span className="text-green-400 font-semibold">{p.savings}% બચત</span>
              </div>
              <div className="mt-6 grid grid-cols-2 gap-3">
                <div className="flex items-center gap-2 rounded-xl border border-purple-900/60 px-3 py-2 text-sm text-gray-200"><Home className="w-4 h-4 text-pink-400" /> ઘરેથી પિકઅપ</div>
                <div className="flex items-center gap-2 rounded-xl border border-purple-900/60 px-3 py-2 text-sm text-gray-200"><Building2 className="w-4 h-4 text-pink-400" /> ઓફિસથી પિકઅપ</div>
                <div className="flex items-center gap-2 rounded-xl border border-purple-900/60 px-3 py-2 text-sm text-gray-200"><ShieldCheck className="w-4 h-4 text-pink-400" /> સલામત & સગવડભર્યું</div>
                <div className="flex items-center gap-2 rounded-xl border border-purple-900/60 px-3 py-2 text-sm text-gray-200"><Sparkles className="w-4 h-4 text-pink-400" /> ઝંઝટ-મુક્ત</div>
              </div>
              <Button onClick={() => onBook('luxury')} className="gradient-btn rounded-full h-12 px-6 mt-7 font-semibold">
                Luxury પેકેજ બુક કરો <ChevronRight className="w-4 h-4 ml-1" />
              </Button>
            </div>
            <div>
              <h4 className="text-white font-semibold mb-4">પેકેજમાં સમાવિષ્ટ</h4>
              <div className="grid sm:grid-cols-2 gap-x-5 gap-y-2.5">
                {p.services.map((s, i) => (
                  <div key={i} className="flex items-start gap-2 text-sm text-gray-200">
                    <Check className="w-4 h-4 text-pink-400 mt-0.5 shrink-0" /> {s}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
